import { getUpgradeBannerSnoozeFetcher } from "@api/fetcher/ambassdor";
import { useMutation } from "@tanstack/react-query";

type Props = {
    data: any;
    error: any;
    mutate: any;
};

const useUpgradeBannerSnooze = (): Props => {
    const { data, error, mutate } = useMutation<any, Error, any>({
        mutationKey: [`upgrade-banner-snooze`],
        mutationFn: getUpgradeBannerSnoozeFetcher,
        retry: false,
    });

    return {
        data: data,
        error,
        mutate,
    };
};

export default useUpgradeBannerSnooze;
